import React from "react";
import { Table, Modal } from "antd";

const DynamicTableModal = ({
  mkir,
  isModalVisible,
  handleOk,
  handleCancel,
  selectedIndex,
  updateProdConsumDet,
}) => {
  console.log(mkir);
  // Extract fields for table headers
  const columns = mkir.fields.map((field) => ({
    title: field.name, // Use field name as column title
    dataIndex: field.name, // Map column to corresponding row key
    key: field.name,
    width: 200,
  }));

  // Prepare rows for the table
  const data = mkir.rows.map((row, index) => ({
    key: index, // Unique key for each row
    ...row, // Spread row data to match dataIndex
  }));

  return (
    <Modal
      title="Select From Here"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="90%"
      style={{ top: 0 }}
    >
      <Table
        columns={columns}
        dataSource={data}
        onRow={(record) => ({
          onClick: () => updateProdConsumDet(record, selectedIndex), // Call parent function on row click
        })}
        bordered
        pagination={{ pageSize: 5 }}
        scroll={{ x: "90%", y: "60vh" }}
        style={{ lineHeight: "30px" }}
        rowStyle={(record, index) => ({
          backgroundColor: record.someCondition
            ? "#ffcccc"
            : index % 2 === 0
            ? "#ffffff"
            : "#f0f0f0",
        })}
      />
    </Modal>
  );
};

export default DynamicTableModal;
